<template>
  <div>
    <div class="row" v-if="hasUpdate">
      <div class="col-sm-12" style="padding-top: 10px;">
        <div class="alert alert-warning">
          <div v-if="updateMessage.version !== currentVersion">
            <strong>Nova atualização disponível:</strong> <br />
            Versão: {{ updateMessage.version }}
          </div>
          <div v-else="">
            <strong>Nova atualização disponível</strong>
          </div>
          <button type="button" class="btn btn-default btn-block" @click.prevent="update()">
            Atualizar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { version } from '../../package.json'
export default {
  name: 'updater',
  data() {
    return {
      hasUpdate: false,
      updateMessage: {},
      currentVersion: version
    }
  },
  mounted() {},
  methods: {
    update() {
      window.location.reload(true)
    }
  }
}
</script>

<style lang="css"></style>
